<template>
  <div class="hidden md:min-w-0 md:flex-1 md:flex md:items-center md:justify-between">
    <div class="min-w-0 flex-1"></div>
    <div class="ml-10 pr-4 flex-shrink-0 flex items-center space-x-10">
      <div class="flex items-center gap-4">
        <CompanySelect />

        <Menu as="div" class="relative inline-block text-left">
          <MenuButton
            data-cy="dropdown"
            class="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
          >
            <Avatar :size="35" backgroundColor="blue" :username="username" color="white" />
          </MenuButton>

          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <MenuItems
              class="origin-top-right absolute z-30 right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <div class="py-1">
                <MenuItem v-if="!isTemporary">
                  <router-link
                    to="/profile"
                    class="block px-4 py-2 text-sm text-gray-700"
                    exact
                    exact-active-class="bg-gray-100 text-gray-800"
                  >
                    <span>{{ $t('label.yourProfile') }}</span>
                  </router-link>
                </MenuItem>
                <MenuItem>
                  <router-link
                    to="/change-password"
                    class="block px-4 py-2 text-sm text-gray-700"
                    exact
                    exact-active-class="bg-gray-100 text-gray-800"
                  >
                    <span>{{ $t('label.changePassword') }}</span>
                  </router-link>
                </MenuItem>
                <MenuItem>
                  <a
                    class="logout block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                    @click="logout"
                    data-cy="logout"
                  >
                    {{ $t('button.logout') }}
                  </a>
                </MenuItem>
              </div>
            </MenuItems>
          </transition>
        </Menu>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { useStore } from 'vuex'
import CompanySelect from './CompanySelect.vue'

export default defineComponent({
  name: 'UserBox',
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    CompanySelect,
  },
  setup() {
    const store = useStore()

    const user = computed(() => store.getters['user/user'])
    const isTemporary = computed(() => store.getters['user/isTemporary'])
    const username = computed(() => `${user.value?.firstName} ${user.value?.lastName}`)

    const logout = () => {
      store.commit('SET_LOADING', true)
      store.dispatch('auth/actLogout').finally(() => store.commit('SET_LOADING', false))
    }

    return {
      user,
      username,
      logout,
      isTemporary,
    }
  },
})
</script>
